var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86674 10.5062C2.6633 10.3318 2.56158 10.2446 2.52432 10.1409C2.4916 10.0498 2.4916 9.9502 2.52432 9.85914C2.56158 9.75539 2.6633 9.6682 2.86674 9.49383L9.92568 3.44331C10.2759 3.14315 10.451 2.99306 10.5992 2.98939C10.728 2.98619 10.8511 3.04279 10.9325 3.14269C11.0262 3.25764 11.0262 3.48825 11.0262 3.94948V7.52886C12.8051 7.84007 14.4332 8.74146 15.6431 10.0949C16.9622 11.5704 17.6918 13.48 17.6929 15.4591V15.9691C16.8184 14.9157 15.7266 14.0638 14.4922 13.4716C13.404 12.9495 12.2275 12.6403 11.0262 12.5588V16.0505C11.0262 16.5117 11.0262 16.7424 10.9325 16.8573C10.8511 16.9572 10.728 17.0138 10.5992 17.0106C10.451 17.0069 10.2759 16.8569 9.92568 16.5567L2.86674 10.5062Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply2);
export default __webpack_public_path__ + "static/media/reply (2).6559596629a407ec0a2be849b669ab76.svg";
export { ForwardRef as ReactComponent };